/**
 * Toggles de facturación (factura global, facturar al reservar): APAGAR siempre se permite.
 * El emisor CFDI (y Pagos, en facturar al reservar) solo se exige para ACTIVAR.
 * Antes, sin emisor el botón "Desactivar" quedaba deshabilitado y la sección ni se mostraba
 * sin persona en el PAC: un toggle encendido no se podía apagar (staging, 14-oct).
 */
export function bookingInvoiceButton(o: { enabled: boolean; gate: boolean; folioNoticeNeeded: boolean; folioAck: boolean; busy: boolean }) {
  const blockedOn = !o.enabled && (!o.gate || (o.folioNoticeNeeded && !o.folioAck));
  return {
    disabled: o.busy || blockedOn,
    label: o.busy ? 'Guardando…' : o.enabled ? 'Desactivar' : 'Activar',
    title: !o.enabled && !o.gate ? 'Requiere emisor CFDI + Pagos activos' : undefined,
  };
}

/** La sección de un toggle se muestra si el emisor ya tiene persona en el PAC o si el toggle está encendido (para poder apagarlo). */
export const showInvoiceToggle = (personLinked: boolean | undefined, enabled: boolean | undefined) => Boolean(personLinked || enabled);

/**
 * V223 (R-01) — "Facturar al reservar" solo existe en Wellness y Boutique: las reservas de
 * GastroGest no se cobran. Si ya estaba encendido (guardado antes de la regla) se sigue
 * mostrando, solo para poder apagarlo. `available` undefined (backend viejo) = se muestra.
 */
export const showBookingInvoice = (available: boolean | undefined, enabled: boolean | undefined) =>
  available !== false || Boolean(enabled);
